import { cva } from 'class-variance-authority';

const segmentedTabsListBase =
  'inline-flex items-center gap-2 h-auto border-2 border-border bg-card p-1.5 rounded-xl shadow-sm text-foreground';

const segmentedTabsTriggerBase =
  'inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-border bg-card text-muted-foreground shadow-sm hover:border-primary/40 hover:text-foreground data-[state=active]:border-2 data-[state=active]:border-primary data-[state=active]:bg-card data-[state=active]:text-foreground data-[state=active]:font-semibold data-[state=active]:shadow-lg data-[state=active]:shadow-primary/15';

export const segmentedTabsListVariants = cva(segmentedTabsListBase, {
  variants: {
    variant: {
      pill: 'flex flex-nowrap w-full justify-start overflow-x-auto scrollbar-hide sm:w-fit',
      compact: 'h-auto w-full flex flex-wrap justify-start',
      primary: 'w-full max-w-md mx-auto grid grid-cols-2',
      profile:
        'flex flex-nowrap justify-start overflow-x-auto scrollbar-hide sm:justify-center sm:w-fit mx-auto w-full max-w-2xl',
    },
  },
  defaultVariants: {
    variant: 'pill',
  },
});

export const segmentedTabsTriggerVariants = cva(segmentedTabsTriggerBase, {
  variants: {
    variant: {
      pill: 'flex-1 sm:flex-initial shrink-0 px-3 sm:px-6 py-2 text-xs sm:text-sm gap-1.5 sm:gap-2 rounded-lg',
      compact: 'rounded-lg px-4 py-2 text-sm',
      primary:
        'rounded-lg px-4 py-2.5 font-bold data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-primary/25',
      profile:
        'flex-1 sm:flex-initial shrink-0 flex-row gap-2 rounded-lg border-transparent bg-transparent shadow-none px-3 sm:px-4 py-2.5 text-xs sm:text-sm min-w-0 hover:bg-muted/50 hover:border-transparent data-[state=active]:border data-[state=active]:border-primary data-[state=active]:bg-primary/10 data-[state=active]:text-primary data-[state=active]:shadow-none',
    },
  },
  defaultVariants: {
    variant: 'pill',
  },
});

export type SegmentedTabsVariant = NonNullable<
  Parameters<typeof segmentedTabsListVariants>[0]
>['variant'];
